import { onDocumentScroll } from "./js/utils";

type OpenState = "open" | "closed";

function mobileMenu(
  items: NodeListOf<HTMLLIElement>,
  outerElement: Element,
  options?: {
    onToggle?: (open: OpenState) => void;
    onError?: (error: unknown) => void;
    onInit?: (menuWrapper: HTMLDivElement) => void;
  }
) {
  try {
    // This will take an array of children which we use for the menu.
    // * It will have a local state of open/closed.
    // * It will need an outer element to put the items NEXT TO (before).
    //   (CSS will control which one of those is displayed when.)
    // * It accepts an optional options object with an onToggle function
    //   which gets called when state changes.
    // * It returns a function with which you can toggle the menu state
    //   from the outside.

    // All internal state is here!
    let openState: OpenState = "closed";

    // This wrapper will have a button for toggling the visisbility
    // of the menu, and a <ul> for all the items.
    const menuWrapper = document.createElement("div");
    menuWrapper.className = "mobile-menu";

    // The UL hodling the children...
    const menuUl = document.createElement("ul");
    menuUl.className = "mobile-menu__menu";

    // Add clones of all the current menu items...
    for (let i = 0; i < items.length; i++) {
      menuUl.appendChild(items[i].cloneNode(true));
    }

    // The button
    const menuButton = document.createElement("button");
    menuButton.textContent = "☰";
    menuButton.className = "mobile-menu__button";

    // Function for toggling the menu
    function toggleMenu() {
      openState = openState === "open" ? "closed" : "open";
      if (openState === "open") {
        menuButton.textContent = "✕";
        menuUl.classList.add("mobile-menu__menu--open");
        menuButton.classList.add("mobile-menu__button--open");
      } else {
        menuButton.textContent = "☰";
        menuUl.classList.remove("mobile-menu__menu--open");
        menuButton.classList.remove("mobile-menu__button--open");
      }
      options?.onToggle && options?.onToggle(openState);
    }
    menuButton.addEventListener("click", toggleMenu);

    // Add the items...
    menuWrapper.appendChild(menuButton);
    menuWrapper.appendChild(menuUl);

    // Add the mobile menu to the DOM
    outerElement.parentNode?.insertBefore(menuWrapper, outerElement);

    // Let's return some helpers to change the state from outside
    // if that would be needed.
    options && options.onInit && options.onInit(menuWrapper);
    return { toggleMenu };
  } catch (e: unknown) {
    console.error("Error when running mobileMenu()", e);
    options?.onError && options?.onError(e);
  }
}

export function explainerMobileMenu() {
  try {
    // We need a bunch of items and an outer element to put
    // the mobile menu inside.
    const items: NodeListOf<HTMLLIElement> = document.querySelectorAll(
      ".header__nav .menu li"
    );
    const outerElement = document.querySelector(".header__nav .menu");

    // (We currently do not care about the returned toggleMenu function.)
    outerElement &&
      mobileMenu(items, outerElement, {
        onToggle: (open) => {
          document.body.classList.toggle(
            "mobile-menu-is-open",
            open === "open"
          );
        },
      });

    const mobileMenuEl =
      outerElement?.parentElement?.querySelector(".mobile-menu");

    const headerWrapper = document.querySelector('.header__inner--explainer')
    if (mobileMenuEl && outerElement) {
      let switchingFlexTimer: number;
      const switchMenusOnScroll = () => {
        clearTimeout(switchingFlexTimer);
        if (headerWrapper) {
          if (window.scrollY > 40) {
            headerWrapper.classList.add('header__inner--scrolled')
          } else {
            headerWrapper.classList.remove('header__inner--scrolled')
          }
        }
      };
      onDocumentScroll(() => {
        switchMenusOnScroll();
      });
      setTimeout(switchMenusOnScroll, 100);
    }
  } catch (e) {
    console.error("Error when running explainerMobileMenu()", e);
  }
}
